export default __webpack_public_path__ + "static/media/chatBubble.ece033a9.svg";